import { ButtonGroup } from '@design/components/button-group/ButtonGroup';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { PickedThemePerformanceSortHorizon } from '@terminal/views/theme-overview/theme-overview-drawer/components/theme-performance-section/chart-title/ChartTitle';
import { useTranslation } from 'react-i18next';

import styles from './HorizonSelector.module.scss';

interface HorizonSelectorProps {
  activeHorizon: PickedThemePerformanceSortHorizon;
  onChange: (horizon: PickedThemePerformanceSortHorizon) => void;
}

export const HorizonSelector = ({
  activeHorizon,
  onChange,
}: HorizonSelectorProps) => {
  const { t } = useTranslation(['widget']);

  const isIntradayChartEnabled = useFlags(state =>
    state.getFeatureFlagState('theme_intraday_chart')
  );

  const horizons: Partial<Record<PickedThemePerformanceSortHorizon, string>> = {
    ...(isIntradayChartEnabled && {
      intraday: t('widget:assetOverview.horizon_intraday'),
    }),
    '1w': t('widget:assetOverview.horizon_1w'),
    '1m': t('widget:assetOverview.horizon_1m'),
    '3m': t('widget:assetOverview.horizon_3m'),
    '6m': t('widget:assetOverview.horizon_6m'),
    '1y': t('widget:assetOverview.horizon_1y'),
  };

  const horizonKeys = Object.keys(
    horizons
  ) as PickedThemePerformanceSortHorizon[];

  return (
    <div className={styles.container}>
      <span className={styles.title}>
        {t('themeOverview.themePerformanceTitle')}
      </span>
      <ButtonGroup
        className={styles.buttonGroup}
        data-testid="horizon-btn-group"
        labels={Object.values(horizons)}
        activeIndex={horizonKeys.indexOf(activeHorizon)}
        onClick={index => onChange(horizonKeys[index])}
      />
    </div>
  );
};
